<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div v-if="!showEdicao" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Usuário</label>
                <div class="field-label field-label-end" >{{ formatInteger(objView.cdusuario) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <div class="field-label">{{ objView.nmusuario }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">CPF</label>
                <div class="field-label field-label-center">{{ objView.cpf }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Status</label>
                <div class="field-label field-label-center">{{ objView.xativo }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Endereço</label>
                <div class="field-label">{{ objView.endereco }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Bairro</label>
                <div class="field-label">{{ objView.bairro || 'Não informado' }}</div>
            </div>
  
            <div class="form-item-char30">
                <label class="label-caption">Município</label>
                <div class="field-label">{{ objView.nmmunicipio }}</div>
            </div>
        
            <div class="form-item-char05">
                <label class="label-caption">UF</label>
                <div class="field-label field-label-center">{{ objView.uf }}</div>
            </div>
        </div>

  
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">CEP</label>
                <div class="field-label">{{ objView.cep }}</div>
            </div>
        
            <div class="form-item-telefone">
                <label class="label-caption">Telefone</label>
                <div class="field-label">{{ objView.fone }}</div>
            </div>
        
            <div class="form-item-telefone">
                <label class="label-caption">Celular</label>
                <div class="field-label">{{ objView.celular }}</div>
            </div>
        
            <div class="form-item">
                <label class="label-caption">E-mail</label>
                <div class="field-label">{{ objView.email }}</div>
            </div>
        </div>

        
  
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Perfil</label>
                <div class="field-label">{{ objView.xperfil }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Registro Órgão</label>
                <div class="field-label">{{ objView.registro_orgao }}</div>
            </div>
        
            <div class="form-item">
                <label class="label-caption">Número Registro</label>
                <div class="field-label">{{ objView.registro_numero }}</div>
            </div>
        
            <div class="form-item">
                <label class="label-caption">Matrícula Número</label>
                <div class="field-label">{{ objView.matricula_numero }}</div>
            </div>
        </div>
        
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ objView.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>
        </div>
  
        <div class="row-end">
            <button v-if="objView.nivel === 999" type="button" 
                @click="showModalEp=true">Trocar EP</button>
            <button type="button" @click="showModalSenha=true">Redefinir Senha</button>
            <button type="button" @click="showEdicao=true">Alterar</button>
            <button type="button" @click="closePage">Fechar</button>
        </div>        
    </div>


    <div>
        <RedefinirLoginSenhaModal
            :visible="showModalSenha"
            @update:visible="(value) => (showModalSenha = value)"
            @submit="redefinirLoginSenha" />
    </div>


    <div>
        <TrocarEpModal
            :showModal="showModalEp"
            @close="showModalEp = false"
            @epSelecionada="trocarEp" />
    </div>


    <div v-if="showEdicao">
        <UsuarioEditPage :idEdicao="idUsuario" @close="showEdicao = false" @save="lerDados" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { formatInteger } from '@/funcoes/utils';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import RedefinirLoginSenhaModal from '@/components/RedefinirLoginSenhaModal.vue';
import TrocarEpModal from '@/components/TrocarEpModal.vue';
import UsuarioEditPage from '../formularios/UsuarioEditPage.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const idUsuario=ref(null);
const isLoading=ref(false);
const msg=ref(null);
const objView=ref({});
const showEdicao=ref(false);
const showModalEp=ref(false);
const showModalSenha=ref(false);

const closePage = () => {emit('close');}

const lerDados = async() => {
    idUsuario.value = props.idView;
    if (idUsuario.value == 0) idUsuario.value = globalStore.idusuario;
    try{
        msg.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/usuarios', {idep: globalStore.idep, id: idUsuario.value});
        Object.assign(objView.value, req[0]);
    } catch (error){msg.value= error;
    } finally {isLoading.value = false;}
}

const redefinirLoginSenha = async({username, senha}) => {
    try{
        msg.value = null;
        isLoading.value = true;
        const ok = await Api.loginDisponivel(objView.value.id, username);
        if (!ok) throw new Error('"Login" indisponível... necessário registrar outro');
        const r = await Api.genericPut('/cad/usuario', {id: objView.value.id, login: username, senha: senha});
        if (r.bolok == 1){msg.value="Nova senha alterada com sucesso"}else{msg.value=r.error}
    } catch (error) {msg.value = `ATENÇÃO: ${error.message}`;
    }finally {isLoading.value = false}
}

const trocarEp = async(ep) => {
    try{
        msg.value = null;
        isLoading.value=true;
        const r = await Api.genericPut('/cad/usuario', {id: objView.value.id, idep: ep.id});
        if (r.bolok==1){
            globalStore.idep     = ep.id;
            globalStore.nmep     = ep.nmep;
            closePage();
        }else{msg.value=r.error}
    } catch (error){msg.value= error;
    }finally{isLoading.value=false;}
}

onMounted(lerDados)
</script>